import { render, staticRenderFns } from "./TeamsAssistente.vue?vue&type=template&id=2eda2eab&scoped=true&"
import script from "./TeamsAssistente.vue?vue&type=script&lang=js&"
export * from "./TeamsAssistente.vue?vue&type=script&lang=js&"
import style0 from "./TeamsAssistente.vue?vue&type=style&index=0&id=2eda2eab&scoped=true&lang=css&"
import style1 from "./TeamsAssistente.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda2eab",
  null
  
)

export default component.exports